import React, { useState, useEffect, useRef } from 'react';
import Form, { useForm } from '../../../../../../../common/components/Form';
import { withStyles } from 'tss-react/mui';
import {
  Button,
  TextField,
  MenuItem,
  Checkbox,
  FormControlLabel,
  RadioGroup,
  Radio,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Modal,
  Fade,
  FormGroup,
} from '@mui/material';
import { useIntl } from 'react-intl';
import { LibraryItem, ResourceLibraryFormState } from '../../../types/library-types';
import {
  ResourceType,
  PublishStatus,
  LibraryPublishStatus,
  YesAndNo,
  ProductType,
  targetReceiver,
  productType,
} from '../../../constants';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SubFormList from './SharedInfoForm';
import AddIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import TableInput from './TableInput';
import { useCommonStyles } from '../../../../../../../common/styles/common-styles';
import ButtonDialog from '../../../../../../../common/components/ButtonDialog';
import DateTimeRangePicker from '../../../../../../../common/components/DateTimeRangePicker';
import moment from 'moment';
import EditMaterialSetList from '../../List/EditMaterialSetList';
import {
  NumberGreaterThanZeroPattern,
  disableInputInvalidValueForWeight,
  getEnabledCustomWeight,
} from 'src/app/common/utils';
import PruDialog from '../../../../../../../common/components/PruDialog';
import { removeMaterialFromSets } from '../../../utils/common-utils';
import { fetchCategoryItem, fetchCategoryList } from '../../../../Category/network/categoryCrud';
import { CategoryLevel, CategoryPaginateList } from '../../../../Category/types/category-types';
import { fetchAllColumns } from '../../../../Column/network/columnCrud';
import { fetchLibraryList, validateColumWeight } from '../../../network/libraryCrud';
// import { useLang } from 'src/app/i18n';
import { regionLocale, RegionLocale, regionLocaleMap } from 'src/app/i18n';

import TargetAgent from './TargetAgent';
import { useSelector } from 'react-redux';
import { Configuration } from 'src/app/modules/Config/types/config-type';
import { RootState } from 'src/redux/store';
import { get } from 'lodash';
import { useStyles, weightFormItem } from './main-form.style';

// PVA
import { makeStyles } from 'tss-react/mui';
import { useDispatch } from 'react-redux';
import { isSaleModule as isSaleModuleFn } from '../../../utils/common-utils';
import { ETypeOfView, typeOfViewOptions } from 'src/app/common/types/view-types';
import { CategoryItem } from '../../../../Category/types/category-types';
import { MentionsInput, Mention, MentionItem } from 'react-mentions';
import { EModuleTypes } from '../../../types/library-types';
import { RegisterPageType } from '../../../constants';
import CheckBoxUserGroup from 'src/app/common/components/CheckBoxUserGroup';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';

const ENABLE_DESIGNATION = window.envConfig['ENABLE_DESIGNATION'];
const ENABLE_ZONE = window.envConfig['ENABLE_ZONE'];

// PVA
const MentionList = [
  { id: 'name', display: 'Name' },
  { id: 'phone', display: 'Phone' },
];
const useStylesCustom = makeStyles()((theme) => ({
  container: {
    padding: 20,
    marginBottom: 20,
    borderRadius: 5,
    backgroundColor: theme.palette.common.white,
  },
  accordContainer: {
    borderRadius: 5,
    backgroundColor: theme.palette.common.white,
  },
  footerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  divideMargin: {
    // marginBottom: 10
  },
  subHeader: {
    fontSize: '1.1rem',
    fontWeight: 'bold',
  },
  accordHeading: {
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '15%',
    flexShrink: 0,
  },
  accordSecondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 15,
  },
  rowContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  addNewMaterialSetBtn: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '10px',
  },
  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalBg: {
    width: '100%',
    backgroundColor: theme.palette.common.white,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2),
    height: '100%',
    overflow: 'scroll',
  },
  modalButtons: {
    marginTop: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  customMentionInput: {
    '& textarea': {
      borderRadius: '4px',
      padding: '5px 5px',
    },
    '& ul': {
      border: '1px solid #dedede',
    },
  },
  focusedMention: {
    backgroundColor: '#dedede',
  },
}));

const StyledRadioGroup = withStyles(RadioGroup, {
  root: {
    flexDirection: 'row',
    display: 'flex',
    '& .MuiFormControlLabel-root': {
      marginBottom: 0,
      marginLeft: 0,
      marginRight: '15px',
    },
    '& .MuiButtonBase-root': {
      padding: 0,
    },
  },
});

const generateDefaultExpandPanel = (regionLocales: string[]) => {
  let expandPanel: any = {};
  regionLocales.map((item) => {
    return (expandPanel[item] = true);
  });
  return expandPanel;
};

export const renderDisplayStatusField = (rowData: ResourceLibraryFormState): string => {
  switch (rowData.status) {
    case LibraryPublishStatus.PublishToSetOnly:
      return 'component.status.publishedToSetOnly';
    case LibraryPublishStatus.Publish:
      return 'component.status.published';
    case LibraryPublishStatus.Unpublished:
      return 'component.status.unpublished';
    case LibraryPublishStatus.Draft:
    default:
      return 'component.status.draft';
  }
};

interface FormListProp {
  disabled: boolean;
  onSave: (formData: ResourceLibraryFormState, columnOptions: ColumnOptions) => void;
  blockName: string;
  categoryType: string;
  moduleType: string;
  blockType: string;
  columnType: string;
  initialValues: ResourceLibraryFormState;
  isEdit: boolean;
  history: any;
  location?: any;
  match?: any;
  currentId?: string;

  loadingFun?: () => void;
}

export type ColumnOptions = {
  label: string;
  value: string;
  id: string;
}[];

interface OptionItem {
  title: string | React.ReactNode;
  value: string;
  children?: OptionItem[];
}

const FormList: React.FC<FormListProp> = (props) => {
  // PVA
  const dispatch = useDispatch();

  // const locale = useLang();
  const { classes } = useStyles();
  const classesCustom = useStylesCustom().classes;

  const { classes: commonClasses } = useCommonStyles();
  const { disabled, onSave, blockName, initialValues, isEdit, history, blockType, moduleType, currentId, loadingFun } =
    props;
  const [treeOptions, setTreeOptions] = useState<OptionItem[]>([]);
  const [columnOptions, setColumnOptions] = useState<ColumnOptions>([]);
  const regionLocales = regionLocale;
  const mainLocale = regionLocale[0] || RegionLocale.ENGLISH;
  const [panelExpand, setPanelExpand] = useState<any>(generateDefaultExpandPanel(regionLocales));
  const [openMaterialModal, setOpenMaterialModal] = useState<boolean>(false);
  const [removedMaterials, setRemovedMaterials] = useState<any[]>([]);
  const [publishItems, SetPublishItems] = useState<any[]>([]);
  // eslint-disable-next-line
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [objErrorValidateDialog, setObjErrorValidateDialog] = useState<{ isOpen: boolean; message: string }>({
    isOpen: false,
    message: '',
  });
  // eslint-disable-next-line
  const [isAddColumn, setIsAddColumn] = useState<boolean>(false);
  const [notiMessage, setNotiMessage] = useState<string>(get(initialValues, 'notificationMessage', ''));
  const [form] = useForm();
  const intl = useIntl();
  const Translation = (id: string, variable?: Record<string, string>) => intl.formatMessage({ id }, variable);
  // validate rules
  const config = useSelector<RootState, Configuration | undefined>((state) => state.config.data);
  const productTypes = config?.productTypes ?? [];
  const DEFAULT_REQUIRED_RULES = { required: true, message: Translation('component.form-required-text') };
  const isAdd = isEdit ? false : disabled ? false : true;
  const refEnabledCustomWeight = useRef<boolean>(getEnabledCustomWeight());
  const [isShowPOC, setIsShowPOC] = useState<boolean>(false);

  // PVA
  const DEFAULT_TYPEOFVIEWS_RULES = [
    {
      validator(rule: any, value: any[]) {
        if (value && value.length > 0) {
          const item = value.find((x) => x.type === ETypeOfView.GroupOfUsers);
          if (item && !item.userFile) {
            return Promise.reject(Translation('component.form-required-file-upload'));
          }

          return Promise.resolve();
        } else {
          return Promise.reject(Translation('component.form-required-text'));
        }
      },
    },
  ];
  const isSaleModule = isSaleModuleFn(moduleType);

  const templateOption: ColumnOptions = [
    { label: 'Template 1 - White background', value: 'TEMPLATE1_WHITEBACKGROUND', id: 'TEMPLATE1_WHITEBACKGROUND' },
    { label: 'Template 2 - Black background', value: 'TEMPLATE2_BLACKBACKGROUND', id: 'TEMPLATE2_BLACKBACKGROUND' },
    { label: 'Template 3 - Blue background', value: 'TEMPLATE3_BLUEBACKGROUND', id: 'TEMPLATE3_BLUEBACKGROUND' },
  ];
  // End of PVA

  const dropdownOptions = {
    rType: [
      { displayName: 'File', value: 'file' },
      { displayName: 'Link', value: 'link' },
      { displayName: 'Content', value: 'content' },
      { displayName: 'Material Set', value: 'materialSet' },
      { displayName: 'Text', value: 'text' },
      // PVA not use
      // { displayName: 'Picture', value: 'picture' },
    ],
  };

  const onFinish = (data: ResourceLibraryFormState) => {
    const formData = form.getFieldsValue(true);
    formData.agent = 'designation';
    formData.removedMaterials = removedMaterials;
    if (ENABLE_DESIGNATION !== 'true') {
      formData.designations = [];
    }
    if (ENABLE_ZONE !== 'true') {
      formData.zones = [];
    }
    onSave(formData, columnOptions);
  };

  const DATE_VIDATOR = [
    {
      validator(_: any, value: string) {
        /* PVA custom
        if (refEnabledCustomWeight.current === false && (!value || !value[0])) {
          // effective start time is mandatory when weight off
          return Promise.reject(new Error(Translation('component.form-required-text')));
        }
        */

        if (!value) {
          return Promise.reject(new Error(Translation('component.form-required-text')));
        }
        if (value) {
          if (!value[0]) {
            return Promise.reject(new Error('Please select the Start Date'));
          }
          if (!value[1]) {
            return Promise.reject(new Error('Please select the End Date'));
          }
          if (value[0] && value[1]) {
            if (moment(value[0]).isAfter(moment(value[1]))) {
              return Promise.reject(new Error(Translation('component.form-date-compare')));
            }

            if (moment(value[0]).add(5, 'years').isBefore(value[1])) {
              return Promise.reject(new Error('Effective date duration should not exceed 5 years'));
            }
          }
        }
        return Promise.resolve();
      },
    },
  ];

  // PVA
  const DATE_EVENT_VIDATOR = [
    {
      validator(_: any, value: string) {
        const { effectiveRange } = form.getFieldsValue(true);

        if (!value) {
          return Promise.reject(new Error(Translation('component.form-required-text')));
        }

        if (value && !value[0]) {
          return Promise.reject(new Error('Please select the Start Date'));
        }

        if (value && !value[1]) {
          return Promise.reject(new Error('Please select the End Date'));
        }

        if (value && value[0] && value[1]) {
          if (moment(value[0]).isAfter(moment(value[1]))) {
            return Promise.reject(new Error(Translation('component.form-date-compare')));
          }

          if (effectiveRange) {
            if (effectiveRange[0] || effectiveRange[1]) {
              if (moment(value[0]).isBefore(effectiveRange[0]) || moment(value[1]).isAfter(effectiveRange[1])) {
                return Promise.reject(new Error('Event date duration must be within Effective Date duration'));
              }

              if (moment(value[1]).isAfter(effectiveRange[1])) {
                return Promise.reject(new Error('Topic end time should be <= material end time'));
              }
            }
          }
        }
        return Promise.resolve();
      },
    },
  ];

  const onSaveDraft = () => {
    const formData = form.getFieldsValue(true);
    formData.agent = 'designation';
    if (ENABLE_DESIGNATION !== 'true') {
      formData.designations = [];
    }
    if (ENABLE_ZONE !== 'true') {
      formData.zones = [];
    }
    // const validationList = regionLocales.map((localeItem) => { return [localeItem, 'name'] });
    // set validate for all mandatroy fields not only information
    form
      .validateFields()
      .then((res) => {
        onSave(formData, columnOptions);
      })
      .catch((err) => {
        const { errorFields } = err;
        if (errorFields.length <= 0) {
          onSave(formData, columnOptions);
        }
      });

    return false;
  };

  const onCancel = () => {
    history.goBack();
  };

  const handleMaterialModal = (isOpen: boolean) => {
    setOpenMaterialModal(isOpen);
  };

  const addResoureceToSet = (resources: any) => {
    const allValues = form.getFieldsValue(true);
    const materialSet = form.getFieldValue('materialSet') || [];
    const newData = materialSet.concat(resources);
    const result = { ...allValues, materialSet: newData };
    form.setFieldsValue(result);
    handleMaterialModal(false);
  };

  const clearWeight = (row: number) => {
    if (refEnabledCustomWeight.current) {
      const data = form.getFieldsValue(true);
      data.moduleColumn[row].weight = '';
      form.setFieldsValue({
        ...data,
        moduleColumn: [...data.moduleColumn],
      });
    }
  };

  const handleChange = (locale: string) => (event: any, isExpanded: boolean) => {
    setPanelExpand({ ...panelExpand, [locale]: isExpanded });
  };

  const copyMainLangVersion = (e: React.ChangeEvent<HTMLInputElement>, locale: string) => {
    // e.preventDefault();
    // e.stopPropagation();
    if (e.target.checked) {
      const allValues = form.getFieldsValue(true);
      const to = locale;
      const from = mainLocale;
      const fromValue = allValues[from];
      const result = { ...allValues, [to]: { ...fromValue } };
      form.setFieldsValue(result);
    }
  };
  useEffect(() => {
    getCategoryOptionList();
    getColumnOptionList();
    if (initialValues?.moduleColumn?.length === 0) {
      initialValues.moduleColumn = [
        {
          column: '',
          weight: null,
        },
      ];
    }
    if (!initialValues?.designations) {
      initialValues.designations = [];
    }

    if (!initialValues?.zones) {
      initialValues.zones = [];
    }

    form.setFieldsValue({ ...initialValues });
    getDisplayStatus();
    // eslint-disable-next-line
  }, []);

  const opertaionColumn = Translation('component.formLabel.operation-column');
  const placeSelect = Translation('app.input.placeholder.please-select');
  const selected = Translation('component.formLabel.selected');
  const translatedBlockName = Translation(blockName);

  const getCategoryOptionList = async () => {
    let options: any[] = [];
    const resultList = await fetchCategoryList(
      {
        module: moduleType,
        page: 1,
        pageSize: 1000,
      },
      [],
    );
    options = await appendChildrenDataToList(resultList);
    setTreeOptions(options);
  };

  const getColumnOptionList = async () => {
    let options: any[] = [];
    let resultList = await fetchAllColumns(moduleType);
    resultList.map((item: any) => {
      const displayLabel = regionLocales.map((localItem, index) =>
        item.name[localItem] ? `${index > 0 ? ` (` : ``}${item.name[localItem]}${index > 0 ? `)` : ``}` : ``,
      );
      return options.push({ label: displayLabel, value: item.id, id: item.id });
    });
    setColumnOptions(options as ColumnOptions);
  };

  // COE

  // const appendChildrenDataToList = async (originalPaginateList: CategoryPaginateList): Promise<any[]> => {
  //   let originalList = originalPaginateList.categoryList;
  //   let resultList: any = [];
  //   //Remove if parentExist
  //   originalList = originalList.filter(listItem => !listItem.parent);
  //   //Add childrenItem under
  //   for (let i = 0; i < originalList.length; i++) {
  //     let level2List: any[] = [];
  //     //@ts-ignore
  //     if (originalList[i].children?.count && originalList[i].children?.count > 0) {
  //       //Fetch level1 detail
  //       let listItemDetail = await fetchCategoryItem(originalList[i].id);
  //       //@ts-ignore
  //       for (let j = 0; j < listItemDetail.children.length; j++) {
  //         //Fetch level2 detail
  //         //@ts-ignore
  //         let level2listItemDetail = await fetchCategoryItem(listItemDetail.children[j].id);
  //         let level3List: any[] = [];
  //         //@ts-ignore
  //         if (level2listItemDetail.children && level2listItemDetail.children.length > 0) {
  //           //@ts-ignore
  //           for (let k = 0; k < level2listItemDetail.children.length; k++) {
  //             //@ts-ignore
  //             level3List.push({ level: CategoryLevel.THREE, title: level2listItemDetail.children[k].name, value: level2listItemDetail.children[k].id });
  //           }
  //         }
  //         //@ts-ignore
  //         level2List.push({ level: CategoryLevel.TWO, title: level2listItemDetail.name, value: level2listItemDetail.id, children: level3List?.length > 0 ? level3List : undefined });
  //       }
  //     }
  //     resultList.push({ level: CategoryLevel.ONE, title: originalList[i].name, value: originalList[i].id, children: level2List?.length > 0 ? level2List : undefined })
  //   }
  //   return resultList;
  // }

  // PVA

  const appendChildrenDataToList = async (originalPaginateList: CategoryPaginateList): Promise<any[]> => {
    let originalList = originalPaginateList.categoryList;
    let resultList: any = [];
    //Remove if parentExist
    originalList = originalList.filter((listItem) => !listItem?.parent);
    let level2ListPromise = [];
    //Add childrenItem under
    for (let i = 0; i < originalList?.length; i++) {
      level2ListPromise.push(getChildrenData(originalList, i));
    }

    let level2ListResult = await Promise.all(level2ListPromise);
    for (let i = 0; i < level2ListResult?.length; i++) {
      resultList.push({
        level: CategoryLevel.ONE,
        title: originalList[i].name,
        value: originalList[i].id,
        children: level2ListResult[i]?.length > 0 ? level2ListResult[i] : undefined,
      });
    }

    return resultList;
  };

  const getChildrenData = async (originalList: CategoryItem[], i: number): Promise<any[]> => {
    let level2List: any[] = [];
    //@ts-ignore
    if (originalList[i].children?.count && originalList[i].children?.count > 0) {
      //Fetch level1 detail
      let listItemDetail = await fetchCategoryItem(originalList[i].id);
      //@ts-ignore
      for (let j = 0; j < listItemDetail?.children?.length; j++) {
        //Fetch level2 detail
        //@ts-ignore
        let level2listItemDetail = await fetchCategoryItem(listItemDetail.children[j].id);
        let level3List: any[] = [];
        //@ts-ignore
        if (level2listItemDetail.children && level2listItemDetail.children.length > 0) {
          //@ts-ignore
          for (let k = 0; k < level2listItemDetail.children.length; k++) {
            //@ts-ignore
            level3List.push({
              level: CategoryLevel.THREE,
              title: (level2listItemDetail.children as CategoryItem[])[k].name,
              value: (level2listItemDetail.children as CategoryItem[])[k].id,
            });
          }
        }
        //@ts-ignore
        level2List.push({
          level: CategoryLevel.TWO,
          title: level2listItemDetail.name,
          value: level2listItemDetail.id,
          children: level3List?.length > 0 ? level3List : undefined,
        });
      }
    }
    return level2List;
  };
  // End of PVA

  const renderTreeItem = (
    treeOption: OptionItem,
    level = 0,
    result: { title: React.ReactNode; value: string }[] = [],
  ): { title: React.ReactNode; value: string }[] => {
    result.push({
      title: (
        <span className="tree-select-option" style={{ marginLeft: 18 * level }}>
          {/* PVA */}
          {level === 0 ? (
            <>{treeOption.title}</>
          ) : (
            <>
              <SubdirectoryArrowRightIcon></SubdirectoryArrowRightIcon> {treeOption.title}
            </>
          )}
          {/* End of PVA */}
        </span>
      ),
      value: treeOption.value,
    });
    if (treeOption.children) {
      treeOption.children.forEach((child) => {
        renderTreeItem(child, level + 1, result);
      });
    }
    return result;
  };

  const renderTreeOption = (options: OptionItem[]) => {
    return options
      .map((option) => renderTreeItem(option))
      .flat()
      .map((child) => (
        <MenuItem key={child.value} value={child.value}>
          {child.title}
        </MenuItem>
      ));
  };

  const getSelectedMaterialSet = () => {
    return form.getFieldValue('materialSet');
  };

  // eslint-disable-next-line
  const getModuleColumn = () => {
    return form.getFieldValue('moduleColumn');
  };

  const getRules = (index: number, name: any) => {
    return [
      { required: true, message: Translation('component.form-weight-text') },
      {
        pattern: NumberGreaterThanZeroPattern,
        message: Translation('recruit-library-weight-greater-zero'),
      },
      {
        validator(_: any, value: string) {
          return validateWeight(index, name);
        },
      },
    ];
  };

  const getColumnRules = (index: number, name: any) => {
    return [DEFAULT_REQUIRED_RULES];
  };

  const validateWeight = async (index: number, name: any) => {
    const moduleColumn = getModuleColumn();
    const currentColumn = moduleColumn[index];
    const currentWeight = currentColumn.weight;

    if (!currentWeight || !currentColumn.column) {
      return true;
    }

    const validate = await validateColumWeight(currentColumn.column, currentWeight.toString());

    if (!validate) {
      return Promise.reject(new Error(Translation('component.form-weight-text')));
    }

    return true;
  };

  const onSubmitForm = async (getFieldValue: any) => {
    const status = getFieldValue('status');
    await form.validateFields(['eventDate']);

    if (status === 'Draft') {
      onSaveDraft();
      return;
    }

    if (
      status === 'Unpublished' &&
      initialValues?.parentItems &&
      (initialValues?.parentItems as LibraryItem[])?.length > 0
    ) {
      setOpenDialog(true);
    } else {
      // validate before publishing resources
      const eventInvitation = getFieldValue('eventInvitation');
      if (eventInvitation === YesAndNo.yes) {
        const typeOfViews = getFieldValue('typeOfViews');
        if (typeOfViews?.length > 1) {
          setObjErrorValidateDialog({
            isOpen: true,
            message: Translation('warning.resource.limit_typeOfView_for_event'),
          });
          return;
        }
      }

      status === 'Unpublished' ? submitFormAnyWay() : form.submit();
    }
  };

  const removeFromSets = async () => {
    const { underMaterialSetIDs, resourceId } = initialValues;
    setOpenDialog(false);
    loadingFun && loadingFun();

    removeMaterialFromSets(underMaterialSetIDs, resourceId, blockType, () => {
      const status = form.getFieldValue('status');
      status === 'Unpublished' ? submitFormAnyWay() : form.submit();
    });
  };

  const submitFormAnyWay = () => {
    onSaveDraft();
  };

  const closeWaringDialog = () => {
    setOpenDialog(false);
  };

  const getRemovedMaterial = (items: any) => {
    removedMaterials.push(items);
    setRemovedMaterials(removedMaterials);
  };

  const getDisplayStatus = (selectedType: string = '') => {
    const isMaterialSet = selectedType
      ? selectedType === ResourceType.materialSet
      : form.getFieldValue('rType') === ResourceType.materialSet;
    const isPublishedItem =
      initialValues.status === LibraryPublishStatus.Publish || LibraryPublishStatus.PublishToSetOnly;
    const isDraft = initialValues.status === LibraryPublishStatus.Draft;
    const isUnpublished = initialValues.status === LibraryPublishStatus.Unpublished;

    let displayStatus: any = [];

    if (isMaterialSet) {
      displayStatus = displayStatus.concat([
        isPublishedItem ? undefined : PublishStatus.Draft,
        PublishStatus.Published,
        PublishStatus.Unpublished,
      ]);
    } else if (isAdd || isDraft) {
      displayStatus = displayStatus.concat([
        PublishStatus.Draft,
        PublishStatus.Published,
        PublishStatus.PublishedToSetOnly,
      ]);
    } else if (isPublishedItem) {
      displayStatus = displayStatus.concat([
        PublishStatus.Published,
        PublishStatus.PublishedToSetOnly,
        PublishStatus.Unpublished,
      ]);
    } else if (isUnpublished) {
      displayStatus = displayStatus.concat([
        PublishStatus.Published,
        PublishStatus.PublishedToSetOnly,
        PublishStatus.Unpublished,
      ]);
    } else {
      displayStatus = displayStatus.concat([
        PublishStatus.Draft,
        PublishStatus.Published,
        PublishStatus.PublishedToSetOnly,
        PublishStatus.Unpublished,
      ]);
    }

    SetPublishItems(displayStatus);
  };

  const onChangeMention = (
    event: { target: { value: string } },
    newValue: string,
    newPlainTextValue: string,
    mentions: MentionItem[],
  ) => {
    setNotiMessage(newValue);
    form.setFieldsValue({ notificationMessage: newValue });
  };

  const onShowEvent = () => moduleType === EModuleTypes.Recruit || moduleType === EModuleTypes.Sale;

  const closeErrorValidateDialog = () => {
    let status = false;
    if (status !== objErrorValidateDialog.isOpen) {
      setObjErrorValidateDialog({
        isOpen: status,
        message: objErrorValidateDialog.message,
      });
    }
  };

  return (
    <div>
      <Form form={form} onFinish={onFinish} initialValues={{ ...initialValues }}>
        <div className={classes.container}>
          <div className={classes.headerContainer}>
            <div className={classes.rowContainer}>
              <div className={commonClasses.header}>
                {isEdit
                  ? Translation('component.formTitle.edit')
                  : disabled
                  ? Translation('component.formTitle.detail')
                  : Translation('component.formTitle.add')}
              </div>
            </div>
            <Button variant="contained" color="inherit" onClick={() => history.goBack()}>
              {Translation('global.back.btnText')}
            </Button>
          </div>
          {disabled && (
            <Form.Item label={Translation('component.formLabel.publish-status')}>
              <span>{Translation(renderDisplayStatusField(initialValues))}</span>
            </Form.Item>
          )}
          <Form.Item name="rType" label={Translation('component.formLabel.type')} rules={[DEFAULT_REQUIRED_RULES]}>
            <TextField
              disabled={disabled || initialValues.rType === ResourceType.materialSet}
              select
              margin="dense"
              variant="outlined"
              fullWidth
              placeholder={placeSelect}
            >
              {dropdownOptions['rType'].map((item) => (
                <MenuItem key={item.value} value={item.value} onClick={() => getDisplayStatus(item.value)}>
                  {item.displayName}
                </MenuItem>
              ))}
            </TextField>
          </Form.Item>
          <Form.Item
            name="category"
            label={Translation('component.formLabel.category')}
            rules={[DEFAULT_REQUIRED_RULES]}
          >
            <TextField
              disabled={disabled}
              select
              margin="dense"
              variant="outlined"
              fullWidth
              placeholder={placeSelect}
              className="tree-select"
            >
              {renderTreeOption(treeOptions)}
            </TextField>
          </Form.Item>

          {/*  PVA not use
          {moduleType === 'Recruit' || productTypes.length < 2 ? null : (
            <Form.Item
              name="productType"
              label={Translation('component.formLabel.productType')}
              rules={[DEFAULT_REQUIRED_RULES]}
              shouldUpdate
              initialValue={initialValues.productType}
            >
              <StyledRadioGroup aria-label="contentType" name="contentType">
                {Object.entries(productType(intl)).map(([label, value]) => (
                  <FormControlLabel
                    key={value.key}
                    value={value.key}
                    control={<Radio disabled={disabled} />}
                    label={value.label}
                  />
                ))}
              </StyledRadioGroup>
            </Form.Item>
          )} */}
          {onShowEvent() ? (
            <>
              <Form.Item
                name="eventInvitation"
                label={Translation('component.formLabel.event-invitation')}
                rules={[DEFAULT_REQUIRED_RULES]}
                shouldUpdate
                initialValue={YesAndNo.no}
              >
                <RadioGroup
                  aria-label="contentType"
                  name="contentType"
                  style={{ display: 'flex', flexDirection: 'row' }}
                >
                  {Object.entries(YesAndNo).map(([label, value]) => (
                    <FormControlLabel
                      key={value}
                      value={value}
                      control={<Radio disabled={disabled} />}
                      label={Translation(`app.select.${label}`)}
                    />
                  ))}
                </RadioGroup>
              </Form.Item>
              {isShowPOC ? (
                <Form.Item
                  name="eventPOC"
                  label="POC"
                  rules={[DEFAULT_REQUIRED_RULES]}
                  shouldUpdate
                  initialValue={YesAndNo.no}
                >
                  <RadioGroup
                    aria-label="contentType"
                    name="contentType"
                    style={{ display: 'flex', flexDirection: 'row' }}
                  >
                    {Object.entries(YesAndNo).map(([label, value]) => (
                      <FormControlLabel
                        key={value}
                        value={value}
                        control={<Radio disabled={disabled} />}
                        label={Translation(`app.select.${label}`)}
                      />
                    ))}
                  </RadioGroup>
                </Form.Item>
              ) : null}
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) =>
                  prevValues.eventInvitation !== currentValues.eventInvitation
                }
              >
                {(_, meta, { getFieldValue }) => {
                  const eventInvitation = getFieldValue('eventInvitation');
                  return eventInvitation === YesAndNo.yes ? (
                    <Form.Item name="checkInUrl" label={Translation('component.formLabel.checkin-page-url')}>
                      <TextField
                        disabled={disabled}
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        placeholder={Translation('app.input.placeholder.please-enter')}
                        // helperText="Reference URL: https://check-in-page.webflow.io/"
                      />
                    </Form.Item>
                  ) : null;
                }}
              </Form.Item>

              {!isSaleModule ? (
                <Form.Item noStyle>
                  {(_, meta, { getFieldValue }) => {
                    const eventInvitation = getFieldValue('eventInvitation');
                    const eventType = getFieldValue('rType');

                    return eventInvitation === YesAndNo.yes && eventType === 'link' ? (
                      <Form.Item
                        name="eventInvitationRegisterPageType"
                        label={Translation('component.formLabel.register-page')}
                        rules={[DEFAULT_REQUIRED_RULES]}
                        shouldUpdate
                        initialValue={RegisterPageType.template}
                      >
                        <RadioGroup
                          aria-label="registerPageType"
                          name="registerPageType"
                          style={{ display: 'flex', flexDirection: 'row' }}
                        >
                          {Object.entries(RegisterPageType).map(([label, value]) => (
                            <FormControlLabel
                              key={value}
                              value={value}
                              control={<Radio disabled={disabled} />}
                              label={Translation(`app.select.${label}`)}
                            />
                          ))}
                        </RadioGroup>
                      </Form.Item>
                    ) : null;
                  }}
                </Form.Item>
              ) : null}

              {!isSaleModule ? (
                <Form.Item noStyle>
                  {(_, meta, { getFieldValue }) => {
                    const eventInvitation = getFieldValue('eventInvitation');
                    const eventType = getFieldValue('rType');
                    const eventInvitationRegisterPageType = getFieldValue('eventInvitationRegisterPageType');

                    return eventInvitation === YesAndNo.yes &&
                      eventType === 'link' &&
                      eventInvitationRegisterPageType === RegisterPageType.template ? (
                      <Form.Item
                        name="eventInvitationTemplate"
                        label={Translation('component.formLabel.event-invitation-template')}
                        rules={[DEFAULT_REQUIRED_RULES]}
                      >
                        <TextField
                          select
                          margin="dense"
                          variant="outlined"
                          fullWidth
                          placeholder={placeSelect}
                          disabled={disabled}
                        >
                          {templateOption.map(({ label, value }) => (
                            <MenuItem key={value} value={value}>
                              {label}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Form.Item>
                    ) : null;
                  }}
                </Form.Item>
              ) : null}
            </>
          ) : null}
          <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.rType !== currentValues.rType}>
            {(_, meta, { getFieldValue }) => {
              const resourceType = getFieldValue('rType');
              return resourceType === 'materialSet' ? (
                <>
                  <div
                    className={classes.divideMargin}
                    style={{ marginLeft: '16px', height: '32px', lineHeight: '32px' }}
                  >
                    <span className={classes.subHeader}>{Translation('component.formTitle.information')}</span>
                  </div>
                  {!disabled ? (
                    <div className={classes.addNewMaterialSetBtn}>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          handleMaterialModal(true);
                        }}
                      >
                        {Translation('component.materialset.addNew.text')}
                      </Button>
                    </div>
                  ) : null}
                  <Form.Item
                    name="materialSet"
                    label={selected + ' ' + translatedBlockName}
                    rules={[DEFAULT_REQUIRED_RULES]}
                  >
                    <TableInput
                      disabled={disabled}
                      getRemovedMaterial={getRemovedMaterial}
                      initialValue={initialValues.materialSet}
                    />
                  </Form.Item>
                  {/* <Divider /> */}
                </>
              ) : null;
            }}
          </Form.Item>
          <Form.Item
            name="sourceId"
            label="Source ID"
            rules={[
              {
                max: 50,
                message: `Cannot have more than 50 characters`,
              },
            ]}
            required={false}
          >
            {({ value, onChange }) => (
              <TextField
                disabled={disabled}
                margin="dense"
                variant="outlined"
                fullWidth
                placeholder={Translation('app.input.placeholder.please-enter')}
                value={value}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const rawValue = e.target.value;
                  const cleanedValue = rawValue.replace(/[^a-zA-Z0-9đĐ]/g, '');
                  onChange(cleanedValue);
                }}
                onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => {
                  e.preventDefault();
                  const pastedData = e.clipboardData.getData('text');
                  const cleanedData = pastedData.replace(/[^a-zA-Z0-9đĐ]/g, '');
                  onChange(cleanedData);
                }}
              />
            )}
          </Form.Item>
        </div>
        <div className={classes.accordContainer}>
          <div className={classes.divideMargin} style={{ marginLeft: '16px', height: '32px', lineHeight: '32px' }}>
            <span className={classes.subHeader}>{Translation('component.formTitle.information')}</span>
          </div>
          {regionLocales.map((locale, index) => {
            return (
              <Accordion
                key={index}
                expanded={panelExpand[locale as string]}
                onChange={handleChange(locale)}
                style={{ marginTop: 0 }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
                  <Typography className={classes.accordHeading}>{Translation(regionLocaleMap[locale].name)}</Typography>
                </AccordionSummary>
                <AccordionDetails style={{ display: 'block' }}>
                  {index === 0 || disabled ? null : (
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={(e) => {
                            copyMainLangVersion(e, locale);
                          }}
                          name="copyMainLangVersion"
                          color="secondary"
                        />
                      }
                      label={Translation('newsArticle.common.useMainLangVersionToFillIn', {
                        lang: Translation(regionLocaleMap[mainLocale].name),
                      })}
                    />
                  )}
                  {/* COE */}
                  {/* <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) => prevValues.rType !== currentValues.rType}
                  >
                    {(_, meta, { getFieldValue }) => {
                      const resourceType = getFieldValue('rType');
                      return (
                        <SubFormList
                          activeLang={locale}
                          form={form}
                          disabled={disabled}
                          resourceType={resourceType}
                          nameMaxSize={120}
                          descriptMaxSize={160}
                          getFieldValue={getFieldValue}
                          moduleType={moduleType}
                        />
                      );
                    }}
                  </Form.Item> */}

                  {/* PVA */}
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) =>
                      prevValues.rType !== currentValues.rType ||
                      prevValues.eventInvitation !== currentValues.eventInvitation ||
                      prevValues.eventInvitationRegisterPageType !== currentValues.eventInvitationRegisterPageType
                    }
                  >
                    {(_, meta, { getFieldValue }) => {
                      const resourceType = getFieldValue('rType');
                      const eventInvitation = getFieldValue('eventInvitation');
                      const eventInvitationRegisterPageType = getFieldValue('eventInvitationRegisterPageType');
                      return (
                        <SubFormList
                          eventInvitationRegisterPageType={eventInvitationRegisterPageType}
                          activeLang={locale}
                          form={form}
                          disabled={disabled}
                          resourceType={resourceType}
                          eventInvitation={eventInvitation === YesAndNo.yes}
                          nameMaxSize={120}
                          descriptMaxSize={160}
                          getFieldValue={getFieldValue}
                          moduleType={moduleType}
                        />
                      );
                    }}
                  </Form.Item>
                  {/* End of PVA */}
                </AccordionDetails>
              </Accordion>
            );
          })}
        </div>
        {/* PVA */}
        {isSaleModule ? (
          <div className={classes.container}>
            <div className={classes.divideMargin} style={{ height: '32px', lineHeight: '32px' }}>
              <span className={classes.subHeader}>{Translation('component.formTitle.notification-message')}</span>
            </div>
            <div>
              <div>{Translation('component.noti-message-description')}</div>
              <MentionsInput
                onChange={onChangeMention}
                value={notiMessage}
                singleLine={false}
                style={{ minHeight: '100px', border: 'solid 2px #C4C4C4', borderRadius: '4px' }}
                className={classesCustom.customMentionInput}
              >
                <Mention
                  trigger="@"
                  data={(search) => MentionList.filter((el) => el.display.toLowerCase().includes(search.toLowerCase()))}
                  displayTransform={(id, label) => `@${label}`}
                  markup="@{{__id__}}"
                  renderSuggestion={(entry, search, hightlightedDisplay, index, focused) => (
                    <div style={{ padding: '3px 8px' }} className={focused ? classesCustom.focusedMention : ''}>
                      {hightlightedDisplay}
                    </div>
                  )}
                />
              </MentionsInput>
            </div>
          </div>
        ) : null}
        {/* End of PVA */}
        <div className={classes.container}>
          <div className={classes.divideMargin} style={{ height: '32px', lineHeight: '32px' }}>
            <span className={classes.subHeader}>{Translation('component.formTitle.publishment-settings')}</span>
          </div>

          <Form.Item
            name={'typeOfViews'}
            label={Translation('recruitment.form.typeOfView')}
            rules={DEFAULT_TYPEOFVIEWS_RULES}
            labelTop={true}
            shouldUpdate
          >
            <CheckBoxUserGroup
              disabled={disabled}
              options={typeOfViewOptions}
              aria-label="viewType"
              moduleType={moduleType}
            ></CheckBoxUserGroup>
          </Form.Item>

          <Form.List name="moduleColumn">
            {(fields: any, { add, remove }: any) => {
              return fields.map((field: any, index: any) => (
                <div key={field.key} style={{ display: 'flex', alignContent: 'start' }}>
                  <Form.Item
                    {...field}
                    label={index === 0 ? opertaionColumn : ' '}
                    rules={getColumnRules(index, [field.name, 'column'])}
                    name={[field.name, 'column']}
                    style={{ flex: 1, flexGrow: 1 }}
                  >
                    <TextField
                      disabled={disabled}
                      select
                      margin="dense"
                      variant="outlined"
                      fullWidth
                      placeholder={placeSelect}
                      onChange={() => clearWeight(index)}
                    >
                      {
                        // need to update the component to tree select
                        columnOptions.map(({ label, value }) => (
                          <MenuItem key={value} value={value}>
                            {label}
                          </MenuItem>
                        ))
                      }
                    </TextField>
                  </Form.Item>
                  {refEnabledCustomWeight.current && (
                    <Form.Item
                      name={[field.name, 'weight']}
                      rules={getRules(index, [field.name, 'weight'])}
                      //required={false}
                      style={weightFormItem}
                    >
                      <TextField
                        type="number"
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        placeholder={Translation('component.formLabel.placeholder-weight')}
                        disabled={disabled}
                        inputProps={disableInputInvalidValueForWeight()}
                      />
                    </Form.Item>
                  )}
                  {!disabled ? (
                    <div
                      style={{
                        display: 'flex',
                        width: '100px',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      <AddIcon
                        fontSize="large"
                        onClick={() =>
                          (() => {
                            add();
                            setIsAddColumn(true);
                          })()
                        }
                      />
                      {fields.length > 1 ? <RemoveIcon fontSize="large" onClick={() => remove(field.name)} /> : null}
                    </div>
                  ) : null}
                </div>
              ));
            }}
          </Form.List>
          <Form.Item
            /*
            required={refEnabledCustomWeight.current ? false : true}
            */
            required={true}
            name="effectiveRange"
            label={Translation('component.formLabel.effective-date')}
            rules={DATE_VIDATOR}
          >
            <DateTimeRangePicker disabled={disabled} />
          </Form.Item>

          {/* PVA */}
          {onShowEvent() ? (
            <Form.Item
              shouldUpdate={(prevValues, currentValues) => prevValues.eventInvitation !== currentValues.eventInvitation}
            >
              {(_, meta, { getFieldValue }) => {
                const eventInvitation = getFieldValue('eventInvitation');
                eventInvitation === YesAndNo.yes ? setIsShowPOC(true) : setIsShowPOC(false);
                return eventInvitation === YesAndNo.yes ? (
                  <Form.Item
                    required={true}
                    name="eventDate"
                    label={Translation('component.formLabel.event-date')}
                    rules={[DEFAULT_REQUIRED_RULES, ...DATE_EVENT_VIDATOR]}
                  >
                    <DateTimeRangePicker disabled={disabled} />
                  </Form.Item>
                ) : null;
              }}
            </Form.Item>
          ) : null}
          {/* End of PVA */}

          {!disabled ? (
            <Form.Item
              name="status"
              label={Translation('component.formLabel.publish-now')}
              rules={[DEFAULT_REQUIRED_RULES]}
            >
              <RadioGroup aria-label="contentType" name="contentType" style={{ display: 'flex', flexDirection: 'row' }}>
                {publishItems &&
                  publishItems.map((item: any) => {
                    return (
                      item && (
                        <FormControlLabel
                          key={item.key}
                          value={item.key}
                          control={<Radio disabled={disabled} />}
                          // label={Translation(`component.formSelectItem.${item.value}`)}
                          label={Translation(item.label)}
                        />
                      )
                    );
                  })}
              </RadioGroup>
            </Form.Item>
          ) : null}
          <div className={classes.footerContainer}>
            {!disabled ? (
              <>
                <ButtonDialog
                  onOk={onCancel}
                  dialogTxt={Translation('component.hint.cancel-warning')}
                  btnTxt={Translation('app.button.cancel')}
                />
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) => prevValues.isPublish !== currentValues.isPublish}
                >
                  {(_, meta, { getFieldValue }) => {
                    return (
                      <Button
                        style={{ marginLeft: 20 }}
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          onSubmitForm(getFieldValue);
                        }}
                      >
                        {Translation('app.button.submit')}
                      </Button>
                    );
                  }}
                </Form.Item>
              </>
            ) : null}
          </div>
        </div>
      </Form>

      <Modal
        open={openMaterialModal}
        onClose={(_, reason) => {
          if (reason !== 'backdropClick') {
            handleMaterialModal(false);
          }
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modal}
      >
        <Fade in={openMaterialModal}>
          <div className={classes.modalBg}>
            <div>
              <Button
                onClick={() => {
                  handleMaterialModal(false);
                }}
                style={{ marginLeft: 20 }}
                variant="contained"
              >
                {Translation('global.back.btnText')}
              </Button>
            </div>
            <div>
              <EditMaterialSetList
                {...props}
                blockName={Translation('component.resource.selectNew')}
                blockType={blockType}
                selectedMaterialSet={getSelectedMaterialSet()}
                handleMaterialModal={handleMaterialModal}
                addResoureceToSet={addResoureceToSet}
                moduleType={moduleType}
              />
            </div>
          </div>
        </Fade>
      </Modal>

      <PruDialog
        open={openDialog}
        canCloseDialog={true}
        onCancel={closeWaringDialog}
        onOk={removeFromSets}
        confirmBtnText={Translation('global.text.confirm')}
        canncelBtnText={Translation('app.button.cancel')}
      >
        {Translation('warning.message.unpublish.material')}
      </PruDialog>

      {/* PVA */}
      <PruDialog
        open={objErrorValidateDialog.isOpen}
        canCloseDialog={true}
        hideConfirmBtn={true}
        onCancel={closeErrorValidateDialog}
        canncelBtnText={Translation('global.text.okay')}
      >
        <span style={{ color: 'red' }}>{objErrorValidateDialog.message || ''}</span>
      </PruDialog>
      {/* End of PVA */}
    </div>
  );
};

export default FormList;
